import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Edit(props: any) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M1.75 14.25h.917l9.229-9.23-.917-.916-9.229 9.23v.916zM14.542 4.125l-2.667-2.667.875-.875c.236-.236.531-.35.885-.343.355.007.65.128.886.364l.896.896c.236.236.354.528.354.875s-.118.639-.354.875l-.875.875zM1.125 15.5a.607.607 0 01-.625-.625v-1.792c0-.083.014-.16.042-.229a.636.636 0 01.145-.208L11 2.333 13.667 5 3.354 15.313a.636.636 0 01-.208.145.611.611 0 01-.23.042H1.126zM11.438 4.562l-.459-.458.917.917-.459-.459z'
				fill={props.color || '#98A2B3'}
			/>
		</Svg>
	);
}

export default Edit;
